///<reference path="shared/utils/constants.ts"/>
import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Constants} from './shared/utils/constants';
import {Permission} from './models/permission.model';
import {Broadcaster} from './app.broadcast';
import {HttpClient} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {DialogComponent} from './shared/components/dialog/dialog.component';

import {map} from 'rxjs/operators';
import {APP_CONFIG} from './shared/common/config';
import {TranslatePipe} from '@ngx-translate/core';
import {AuthService} from './components/authentication/authentication.service';
import {DialogLoadingComponent} from './shared/components/dialog-loading/dialog-loading.component';
import {CountryModel} from "./models/country.model";

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public currentPage: string;
  public inprocessApis = [];
  private currentPermission = new Permission();
  private menuCollapsed = false;
  closeDialogSignal$ = new BehaviorSubject(null);
  constructor(
    private router: Router,
    private toaster: ToastrService,
    private broadcast: Broadcaster,
    private http: HttpClient,
    public dialog: MatDialog,
    private translate: TranslatePipe,
    private authen: AuthService,
  ) {
    this.updateTimerRefreshToken();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentPage = event.url;
        this.currentPermission = new Permission();
        if (Constants.PERMISSION_CONSTANT.hasOwnProperty(this.currentPage)) {
          const page = Constants.PERMISSION_CONSTANT[this.currentPage];
          const permission = JSON.parse(
            localStorage.getItem('permission') || '{}',
          );
          if (permission && permission[page]) {
            this.currentPermission.allowReading = permission[page] !== 0;
            this.currentPermission.allowCreating = permission[page] === 2;
            this.currentPermission.allowUpdating = permission[page] === 2;
            this.currentPermission.allowDeleting = permission[page] === 2;
          }
        }
      }
    });
  }

  buildPermissionExport(): boolean {
    const permission: any = localStorage.getItem('permission') || null;
    return (permission) ? (JSON.parse(permission).export === 2) : false;
  }

  getCurrentPermission(path = ''): Permission {
    if (path) {
      this.currentPermission = new Permission();
      if (Constants.PERMISSION_CONSTANT.hasOwnProperty(path)) {
        const page = Constants.PERMISSION_CONSTANT[path];
        const permission = JSON.parse(
          localStorage.getItem('permission') || '{}',
        );
        if (permission && permission[page]) {
          this.currentPermission.allowReading = permission[page] !== 0;
          this.currentPermission.allowCreating = permission[page] === 2;
          this.currentPermission.allowUpdating = permission[page] === 2;
          this.currentPermission.allowDeleting = permission[page] === 2;
        }
        return this.currentPermission;
      }
    }
    return this.currentPermission;
  }

  setMenuCollapsed(): any {
    this.menuCollapsed = !this.menuCollapsed;
  }

  getMenuCollapsed(): boolean {
    return this.menuCollapsed;
  }

  buildMenu(menu: any[]): any {
    const permission = JSON.parse(localStorage.getItem('permission') || '{}');
    const result = [];
    if (permission) {
      menu.forEach((m: any) => {
        if (Constants.PERMISSION_CONSTANT.hasOwnProperty(m.url)) {
          const page = Constants.PERMISSION_CONSTANT[m.url];
          if (
            (permission && permission[page] && permission[page] !== 0) ||
            Constants.PAGE_WITHOUT_PERMISSION.indexOf(m.url) >= 0
          ) {
            result.push(m);
          }
        } else if (m.children) {
          const sub = this.buildMenu(m.children);
          if (sub.length) {
            m.children = sub;
            result.push(m);
          }
        }
      });
    }
    return result;
  }

  showSuccess(msg: string, title?: string, trans?: boolean, timeOut = 3000): void {
    this.toaster.success(msg, title, {
      timeOut,
      positionClass: 'toast-top-center',
    });
  }

  showInfo(msg: string, title?: string, trans?: boolean, timeOut = 3000): void {
    this.toaster.info(msg, title, {
      timeOut,
      positionClass: 'toast-top-center',
    });
  }

  showWarning(msg: string, title?: string, trans?: boolean, timeOut = 3000): void {
    this.toaster.warning(msg, title, {
      timeOut,
      positionClass: 'toast-top-center',
    });
  }

  showError(msg: string, title?: string, trans?: boolean, timeOut = 3000): void {
    if (!trans) {
      this.toaster.error(msg, title, {
        timeOut,
        positionClass: 'toast-top-center',
      });
    } else {
      this.toaster.error(this.translate.transform(msg), title, {
        timeOut,
        positionClass: 'toast-top-center',
      });
    }
  }

  startLoading(url = ''): void {
    this.broadcast.broadcast('LOADING', true);
    if (url && url.indexOf('/api/') > 0) {
      this.closeLoading();
      const unload = localStorage.getItem('un_loading');
      if (!unload) {
        this.loading();
      } else {
        localStorage.removeItem('un_loading');
      }
    }
  }

  stopLoading(): void {
    this.broadcast.broadcast('LOADING', false);
  }

  completeLoading(url = ''): void {
    this.broadcast.broadcast('LOADING', false);
    // if (url && url.indexOf('/api/') > 0) {
    //   this.closeLoading();
    // }
    this.closeLoading();
  }
  loading(): void {
    const data = {
      title: ''
    };
    const dialogRef = this.dialog.open(DialogLoadingComponent, {
      width: 'auto',
      data,
      panelClass: 'loading-dialog',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      //console.log('The dialog was closed');
    });
  }
  closeLoading(): void {
    this.closeDialogSignal$.next(null);
    this.dialog.closeAll();
  }

  changePassword(user: any): Observable<any> {
    const url = `${APP_CONFIG.BASE_API_LINK.BASE + '/change-password'}`;
    return this.http.post(url, user).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  confirm(data: any): Observable<any> {
    return new Observable<any>((observer) => {
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '400px',
        data,
        panelClass: 'confirm-dialog',
      });

      dialogRef.afterClosed().subscribe((result) => {
        // console.log('The dialog was closed');
        observer.next(result);
      });
    });
  }
  updateTimerRefreshToken(): void {
    this.authen.startRefreshTokenTimer();
  }
  loadCountry(): void {
    this.http.get("../assets/country.json")
      .subscribe((data: Array<CountryModel>) => {
        Constants.COUNTRIES = data;
      });
  }
  loadGroupSetting(): void {
    this.http.get("../assets/group.json")
      .subscribe((data: any) => {
        Constants.LABEL_MT4_GROUP = data;
      });
  }
}
